module.exports = __webpack_public_path__ + "static/img/1-1Z524145A6291.decbb6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z524145A6291.jpg
// module id = j8BT
// module chunks = 0